export default __webpack_public_path__ + "static/media/file-web_darkGray2.ec432a49.svg";